// Which pricing card the paywall should recommend, and therefore lead with.
//
// The recommendation is read from the plan argument every `showPaywall` call
// already passes, not from `trigger`. Every gate states the tier the
// blocked action actually needs -- 'pro' for a Pro-only feature such as
// budgeting, 'creator'/'basic' where Creator is enough -- so the requirement
// is already in hand. Deriving it from `trigger` instead would mean a lookup
// row per control (there are ~40 and they are added freely, see the
// vocabulary in services/show-paywall.js) restating what the plan argument
// says, and a new trigger would silently recommend the wrong tier.
//
// Keys are the paywall `type` vocabulary as call sites pass it today; values
// are ids from PLANS. Never map a type to a tier above the one it requires:
// a free-plan limit ('basic') is cleared by the cheapest paid tier, so it
// recommends Creator rather than upselling Pro.
const RECOMMENDED_PLAN_ID_BY_PAYWALL_TYPE = {
  pro: 'pro',
  creator: 'basicPlus',
  basic: 'basicPlus',
  basicPlus: 'basicPlus',
  // The dashboard and competition paywalls render the Creator intro panel
  // (see UpgradePlanModal's MODAL_DATA_MAPPING); the cards now agree with it.
  dashboard: 'basicPlus',
  basicCompetitions: 'basicPlus'
}

// What the modal recommended before this was configurable, and what an
// unmapped or absent type keeps getting: the cheapest paid tier. A tier added
// to PLANS without a row here under-sells rather than over-sells.
const DEFAULT_RECOMMENDED_PLAN_ID = 'basicPlus'

const recommendedPlanId = (paywallType) =>
  RECOMMENDED_PLAN_ID_BY_PAYWALL_TYPE[paywallType] || DEFAULT_RECOMMENDED_PLAN_ID

export {
  RECOMMENDED_PLAN_ID_BY_PAYWALL_TYPE,
  DEFAULT_RECOMMENDED_PLAN_ID,
  recommendedPlanId
}
